import {
  doc,
  setDoc,
  collection,
  query,
  where,
  getDocs,
  orderBy,
  limit
} from "firebase/firestore";
import { db } from "../../firebase";
import Cookies from "js-cookie";
import { Randomcode } from "../../components_root/rendom_code";
import { Serial_number } from "../../components_root/serial_number";
import { number } from "framer-motion";
import { Randomnumber } from "../../components_root/rendom_number";

export const Create_ledger_account = async (data) => {
  const { name, accountguid, account_type } = data || {};

  // Validation
  if (!name?.trim()) {
    return { success: false, error: "Missing name" };
  }
  if (!accountguid?.trim()) {
    return { success: false, error: "Missing accountguid" };
  }
  if (!account_type?.trim()) {
    return { success: false, error: "Missing account_type" };
  }


  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");
  const select_company_uid = Cookies.get("select_company_uid");

  if (!sessiontoken) {
    return { success: false, error: "Session expired. Please relogin." };
  }
  if (!guid) {
    return { success: false, error: "Login expired. Please relogin." };
  }
  if (!select_company_uid || select_company_uid === "undefined" || select_company_uid === "null") {
    return { success: false, error: "Contact service provider." };
  }

  const servicetablename = "companies";
  try {
    // SUBCOLLECTION path
    const ledgerCollection = collection(
      db,
      servicetablename,
      select_company_uid,
      "staff_accounts"
    );

    // Check duplicate accountguid inside company
    const duplicateQuery = query(
      ledgerCollection,
      where("accountguid", "==", accountguid),
    );

    const duplicateSnap = await getDocs(duplicateQuery);

    if (!duplicateSnap.empty) {
      return { success: false, error: "account already listed." };
    }


    // INDEXNUMBER
    // SAVE AREA
    const tablename = "staff_accounts";
    const voucherprintCollection = collection(
      db,
      servicetablename,
      select_company_uid,
      tablename
    );
    let indexnumber = 1;
    let tokennumber = 1;

    const lastIndexQuery = query(
      voucherprintCollection,
      orderBy("date_time", "desc"),
      limit(1)
    );
    let account_number = Randomnumber(8);
    const lastIndexSnap = await getDocs(lastIndexQuery);

    if (!lastIndexSnap.empty) {
      const lastDoc = lastIndexSnap.docs[0].data();
      indexnumber = (lastDoc.indexnumber || 0) + 1;
      const lastDate = lastDoc.date_time?.toDate();
      const lastToken = lastDoc.tokennumber || 0;

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const lastDateOnly = new Date(lastDate);
      lastDateOnly.setHours(0, 0, 0, 0);

      // check date
      if (lastDateOnly.getTime() === today.getTime()) {
        tokennumber = lastToken + 1;    // same day → increment
      } else {
        tokennumber = 1;                // new day → start at 1
      }
    }

    // Create ledger under company  
    const parentDocRef = doc(
      db,
      servicetablename,
      select_company_uid,
      tablename,
      accountguid
    );

    const savequery = {
      ...data,
      queue_verification: false,
      administration_login: false,
      indexnumber,
      tokennumber,
      accountnumber: account_number,
      companyuid: select_company_uid,
      guid,
      sessiontoken,
      date_time: new Date(),
      date_time_update: new Date(),
    };

    await setDoc(parentDocRef, savequery);

    return { success: true };
  } catch (err) {
    console.error("Error saving ledger:", err);
    return { success: false, error: err.message || "Unknown error" };
  }
};
